import { Icon, Text } from '@/components/atoms';
import { PASSWORD_RULES } from '@/utils/constants';
import React, { useMemo } from 'react';
import { SignUpFormFields } from '@/components/organisms/Authentication/SignUpForm';
import { FieldErrors } from 'react-hook-form';

interface IProps {
  value: string;
  errors: FieldErrors<SignUpFormFields>['password'];
}

const PasswordRules = ({ value, errors }: IProps) => {
  const rules = useMemo(() => {
    const rulesWithDisabledProp = [];
    for (let ruleKey in PASSWORD_RULES) {
      const ruleValue = PASSWORD_RULES[ruleKey as keyof typeof PASSWORD_RULES];
      const regexPattern = ruleValue.value;
      const disabled = value ? !regexPattern.test(value) : true;
      rulesWithDisabledProp.push({
        ...ruleValue,
        disabled,
        hasError: errors
          ? errors!.types![ruleKey as keyof typeof PASSWORD_RULES]
          : false,
      });
    }
    return rulesWithDisabledProp;
  }, [value, errors]);

  return (
    <div className="flex justify-start flex-wrap">
      {rules.map((rule) => {
        return (
          <div key={rule.title} className="flex mb-2 w-1/2 items-center">
            {rule.hasError ? (
              <Icon name="close" intent="error" />
            ) : (
              <Icon
                name="checkMark"
                intent={rule.disabled ? 'disabled' : 'primary'}
              />
            )}
            <Text value={rule.title} className="ml-1" />
          </div>
        );
      })}
    </div>
  );
};

export default PasswordRules;
